(function () {
  'use strict';

  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reducedMotionQuery.matches;
  }

  function markVisible(elements) {
    elements.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    var viewHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewHeight * 0.94 && rect.bottom > 0;
  }

  function bindRevealTargets() {
    document.querySelectorAll('.lots__header, .shop-page__header, .why__header, .profiles__header').forEach(function (el) {
      el.setAttribute('data-voitkus-reveal', '');
      if (isInViewport(el)) el.classList.add('is-visible');
    });

    document.querySelectorAll('.lots__grid, .shop-page__grid, .why__grid').forEach(function (el) {
      el.setAttribute('data-voitkus-reveal-stagger', '60');
      if (isInViewport(el)) el.classList.add('is-visible');
    });

    document.querySelectorAll('.profiles--spectrum .profiles__grid').forEach(function (el) {
      if (isInViewport(el)) el.classList.add('is-visible');
    });
  }

  function observeReveal() {
    var revealEls = document.querySelectorAll('[data-voitkus-reveal]');
    var staggerEls = document.querySelectorAll('[data-voitkus-reveal-stagger], .profiles--spectrum .profiles__grid');

    if (prefersReducedMotion()) {
      markVisible(revealEls);
      markVisible(staggerEls);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      markVisible(revealEls);
      markVisible(staggerEls);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (entry.target.closest('.profiles--spectrum')) {
            void entry.target.offsetWidth;
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                entry.target.classList.add('is-visible');
              });
            });
          } else {
            entry.target.classList.add('is-visible');
          }
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.01, rootMargin: '180px 0px 0px 0px' }
    );

    revealEls.forEach(function (el) {
      if (!el.classList.contains('is-visible')) observer.observe(el);
    });
    staggerEls.forEach(function (el) {
      if (!el.classList.contains('is-visible')) observer.observe(el);
    });
  }

  function playHeroKinetic() {
    var hero = document.querySelector('[data-hero-kinetic], .hero--kinetic');
    if (!hero) return;

    if (prefersReducedMotion()) {
      hero.classList.add('is-play');
      return;
    }

    document.documentElement.classList.add('voitkus-motion-ready');
    var delay = window.matchMedia('(max-width: 900px)').matches ? 120 : 32;
    void hero.offsetWidth;
    window.setTimeout(function () {
      void hero.offsetWidth;
      requestAnimationFrame(function () {
        hero.classList.add('is-play');
      });
    }, delay);
  }

  function playFounder(founder) {
    if (!founder || founder.classList.contains('is-play')) return;
    if (prefersReducedMotion()) {
      founder.classList.add('is-play');
      return;
    }
    void founder.offsetWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        founder.classList.add('is-play');
      });
    });
  }

  function observeFounder() {
    var founder = document.querySelector('[data-founder-split], .founder--split');
    if (!founder) return;
    if (prefersReducedMotion() || isInViewport(founder) || !('IntersectionObserver' in window)) {
      playFounder(founder);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          playFounder(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -12% 0px' }
    );
    observer.observe(founder);
  }

  function playDiscoveryWipe(teaser) {
    if (!teaser || teaser.classList.contains('is-play')) return;
    if (prefersReducedMotion()) {
      teaser.classList.add('is-play');
      return;
    }
    document.documentElement.classList.add('voitkus-motion-ready');
    function startWipe() {
      void teaser.offsetWidth;
      window.setTimeout(function () {
        void teaser.offsetWidth;
        requestAnimationFrame(function () {
          teaser.classList.add('is-play');
        });
      }, 80);
    }
    var img = teaser.querySelector('.discovery-teaser__img');
    if (!img || img.complete) {
      startWipe();
      return;
    }
    var settled = false;
    var finish = function () {
      if (settled) return;
      settled = true;
      startWipe();
    };
    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
    window.setTimeout(finish, 900);
  }

  function observeDiscoveryWipe() {
    var teaser = document.querySelector('[data-discovery-wipe], .discovery-teaser--wipe');
    if (!teaser) return;
    if (prefersReducedMotion()) {
      playDiscoveryWipe(teaser);
      return;
    }
    if (isInViewport(teaser) || !('IntersectionObserver' in window)) {
      playDiscoveryWipe(teaser);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          playDiscoveryWipe(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    observer.observe(teaser);
  }

  function observeTasteBars() {
    var block = document.querySelector('.product-taste[data-voitkus-taste]');
    if (!block) return;
    function play() {
      if (block.classList.contains('is-taste-animated')) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          block.classList.add('is-taste-animated');
        });
      });
    }
    if (prefersReducedMotion() || isInViewport(block) || !('IntersectionObserver' in window)) {
      play();
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          play();
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    observer.observe(block);
  }

  function init() {
    bindRevealTargets();
    observeReveal();
    playHeroKinetic();
    observeFounder();
    observeDiscoveryWipe();
    observeTasteBars();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
